import React from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import { CalendarContainer } from 'react-datepicker';
import { FormSelect } from '../FormInputs';
import type { NarrativeFormData } from '../Forms/types';

interface DateRangeSettingsSubgroupProps {
  form: any;
}

export const DateRangeSettingsSubgroup: React.FC<DateRangeSettingsSubgroupProps> = ({ form }) => {
  const { t } = useTranslation();

  const startDate = form.state.values.startDate;
  const endDate = form.state.values.endDate;

  const dateRangePresetOptions = [
    { value: 'FIXED', label: t('Fixed date range') },
    { value: 'YESTERDAY', label: t('Yesterday') },
    { value: 'YESTERDAY_TODAY', label: t('Yesterday - Today') },
    { value: 'LAST_7_DAYS', label: t('Last 7 days') },
    { value: 'CURRENT_WEEK', label: t('Current week') },
    { value: 'LAST_WEEK', label: t('Last week') },
  ];

  const container = ({ children }: { children: React.ReactNode }) => {
    return (
      <div className='react-datepicker custom-datepicker-common'>
        <CalendarContainer className="container">
          <div style={{ position: "relative" }}>{children}</div>
        </CalendarContainer>
      </div>
    );
  };

  return (
    <div className="form-element-group">
      <FormSelect
        form={form}
        name="dateRangePreset"
        label={t('Date range filter preset')}
        placeholder={t('Select option')}
        options={dateRangePresetOptions}
      />

      <form.Subscribe
        selector={(state: any) => state.values.dateRangePreset}
        children={(dateRangePreset: any) => (
          dateRangePreset && dateRangePreset.value === 'FIXED' && (
            <div className="group-card-row">
              <div className="form-element">
                <label>{t('Start date')}</label>
                <form.Field
                  name="startDatePreset"
                  children={(field: any) => (
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      selected={field.state.value}
                      onChange={(date) => field.handleChange(date)}
                      calendarContainer={container}
                      minDate={startDate}
                      maxDate={endDate || new Date()}
                      required
                      showDisabledMonthNavigation
                      placeholderText={t('Select date')}
                    />
                  )}
                />
              </div>

              <div className="form-element">
                <label>{t('End date')}</label>
                <form.Field
                  name="endDatePreset"
                  children={(field: any) => (
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      selected={field.state.value}
                      onChange={(date) => field.handleChange(date)}
                      calendarContainer={container}
                      minDate={form.state.values.startDatePreset}
                      maxDate={endDate || new Date()}
                      showDisabledMonthNavigation
                      placeholderText={t('Select date')}
                    />
                  )}
                />
              </div>
            </div>
          )
        )}
      />
    </div>
  );
};